import React, { FC, memo } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import Offer from '@components/Offer';
import { BrandTypes } from '../../../types/brands';
import { isBenefitItem, TBenefit } from '../../../interfaces/Car';
import { BRAND } from '../../../constants/main';
import routes from '../../../constants/routes';

export const Benefit: FC<{ data?: TBenefit; id: number | string; index: number; disableFocus: boolean }> = memo(
    ({ data, id, index, disableFocus }) => {
        const { asPath } = useRouter();

        const showInfoCircleIcon = (): Icons => {
            switch (true) {
                case asPath === routes.BASKET:
                case asPath.includes(`${routes.CAR}/configurable`) && BrandTypes.OV === BRAND:
                    return Icons.InfoCircle;
                case [BrandTypes.AC, BrandTypes.AP, BrandTypes.OV, BrandTypes.DS].includes(BRAND as BrandTypes):
                    return Icons.InfoCircle;
                default:
                    return Icons.Info;
            }
        };

        if (!data) {
            return null;
        }

        return (
            <li>
                <Offer
                    iconName={showInfoCircleIcon()}
                    text={isBenefitItem(data) ? data.benefitTitle : data.losangeLabel}
                    tooltipText={isBenefitItem(data) ? data.benefitText : data.popupText}
                    id={`trim-item-${id}`}
                    index={index}
                    disableFocus={disableFocus}
                />
            </li>
        );
    }
);
Benefit.displayName = 'Benefit';
